import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appZoom]'
})
export class ZoomDirective {

  constructor(private ref: ElementRef) {
    window.requestAnimationFrame(zoom);
    function zoom() {
      const el = ref.nativeElement;
      const rect = el.getBoundingClientRect();
      const infoHeight = window.innerHeight-80;
      const ratio = (infoHeight-rect.top)/(infoHeight+el.offsetHeight);
      el.style.transform = "scale("+(1+ratio)+")";
      window.requestAnimationFrame(zoom);
    }
  }

  // @HostListener('window:scroll', ['$event'])
  // onScroll1(event: any) {
  //   const el = this.ref.nativeElement;
  //   const rect = el.getBoundingClientRect();
  //   const infoHeight = window.innerHeight-105;
  //   console.log(infoHeight + " - " + rect.top);
  //   const ratio = (infoHeight-rect.top)/(infoHeight+el.offsetHeight);
  //   console.log(1+ratio);
  //   el.style.transform = "scale("+(1+ratio)+")";
  //   this.requestAnimationFrame()
  // }

}
